/**
 * @description toast
 * @author aprilcai
 */
const styleText = `
    .iv-txv-toast {
        display: none;
        min-width: 70%;
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 100;
        transform: translate3d(-50%, -50%, 10px);
        color: #fff;
        background: rgba(0,0,0,.8);
        text-align: center;
        padding: 20px;
        border-radius: 5px;
        max-width: 90%;
    }
    .iv-txv-toast.show {
        display: block;
    }
`;

let toastDisappearTimeoutHandle: any;
export default function toast(content: string) {
  clearTimeout(toastDisappearTimeoutHandle);
  let toastElement: HTMLDivElement = document.querySelector('.iv-txv-toast');
  if (toastElement === null) {
    toastElement = document.createElement('div');
    toastElement.classList.add('iv-txv-toast');
    document.body.append(toastElement);
    const style = document.createElement('style');
    style.textContent = styleText;
    style.type = 'text/css';
    style.id = 'iv-txv-toast-style';
    document.head.appendChild(style);
  }
  toastElement.innerText = content;
  toastElement.classList.add('show');
  toastDisappearTimeoutHandle = setTimeout(() => {
    if (toastElement) {
      toastElement.classList.remove('show');
    }
  }, 3000);
}
